import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import InputCustom from '../../../components/atoms/input/InputCustom'
import { Box } from '@mui/material'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

function WeddingTheme({
  open,
  handleClose,
  handleNext,
  handleBack,
  weddingData,
  setWeddingData,
}) {
    return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a theme in mind?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<Box className={styles.formInputs}>
								<InputCustom
									type="text"
									name="theme"
									placeholder="Wedding Theme"
									value={weddingData.theme}
									setDataFunction={setWeddingData}
									data={weddingData}
									required={true}
									data_cy="weddingTheme"
								/>
							</Box>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => handleNext()}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.99} />
				</div>
			</div>
		</NewWedingModal>
   )
}

export default WeddingTheme